import { render, staticRenderFns } from "./MonitorVitalsAction.vue?vue&type=template&id=1c4b7d1c&"
import script from "./MonitorVitalsAction.vue?vue&type=script&lang=js&"
export * from "./MonitorVitalsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports